import { Box, Checkbox, DialogActions, DialogContent, DialogTitle, FormControlLabel, LinearProgress, List, ListItem, ListItemIcon, ListItemText, Stack, TextField, Typography, alpha } from "@mui/material";
import { UIcon } from "../common/ui.icon";
import { GREY, INFO_COLOR, MAIN_COLOR, MAIN_COLOR_ACTIVE, SECONDARY_COLOR, WARN_COLOR, WHITE } from "../style/theme";
import { UNIT_CATEGORIES, UNIT_XP_PERC, useUnit } from "./unit";
import { UDialgoCloseIcon, UDialog, UDialogClose, UDialogCloseOnCompleteButton, useDialog } from "../common/ui.dialog";
import { useContext, useEffect, useState } from "react";
import { gradient } from "../common/ui.gradient";
import { UButton, UListItemButton } from "../common/ui.buttons";
import { BATTLE_TRAITS, useTraits } from "./unit.traits";
import { CPayButton, RP_COLOR } from "./cr.ui.requisition";
import { WEAPON_MODIFICATIONS } from "./unit.wmod";
import { ULine, UMarginTop, URow } from "../common/ui.page";
import { useRelics } from "./unit.relics";
import { UnitComposition } from "./unit.composition";
import { CUnitEditor } from "./cr.ui.composition";
import { useExt } from "./ext";
import { CUnitListContext } from "./cr.ui.order";
import { PNEX_COLOR } from "./cr.ext.pnex";


export function BStoneIcon(props) {
    const { fragments = 0, size = 32, invert, ...rest } = props;

    var numPos = size / 2.6;
    var fontSize = size / 3;
    if (fontSize < 10) {
        fontSize = 10;
    }

    return <Box {...rest}>
        <Box sx={{ lineHeight: 0, position: 'relative', flex: 0, width: size }}>
            <Typography sx={{
                color: invert ? PNEX_COLOR : '#000', fontWeight: 800,
                position: 'absolute', top: numPos, left: 0, right: 0, fontSize: fontSize, textAlign: 'center'
            }}>
                {fragments}
            </Typography>
            <UIcon size={size} name={invert ? "pnex/bstone" : "pnex/wstone"} />
        </Box>
    </Box>
}